import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { reactSelectCustomStyleCms, numberWithCommas } from 'helper';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import { InputTemplate } from 'modules/common/components/inputComponents';

import * as actions from '../actions';
import * as c from '../constant';

function ApproveConfirmationModal({
  approvePlanning,
  approving,
  formData,
  setFormData,
  id,
  trackingNo,
  getItem,
  refreshList,
  createTextArea,
  getFeesList,
  feesList,
}) {
  const setModal = useContext(ModalContext);
  const [charCount, setCharCount] = useState(0);
  const [isEditing, setIsEditing] = useState('');

  const handleOnKeyUp = (e) => {
    e.preventDefault();

    setCharCount(() => formData?.planning_department_remarks?.length || 0);
  };

  const toggleEdit = (item) => (e) => {
    e.preventDefault();
    setIsEditing(_.get(item, 'name'));
    setFormData({
      ...formData,
      name: _.get(item, 'name'),
      amount: _.get(item, 'amount'),
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      planning_fee: formData.planning_fee,
      planning_department_remarks: formData.planning_department_remarks,
    };
    approvePlanning(id, args, () => {
      setModal({ isOpen: false });
      refreshList(id);
      getItem(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getFeesList({ department: 'PLANNING DEPARTMENT' });
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      planning_fee: feesList.map((item) => {
        return {
          name: _.get(item, 'attributes.name'),
          amount: _.get(item, 'attributes.amount'),
        };
      }),
      tracking_no: trackingNo,
      year: new Date().getFullYear(),
      planning_department_remarks: '',
    });
  }, [feesList]);

  const formValidation = {
    amount: 'required',
  };

  const validateForm = useFormValidator(formData, formValidation);

  useEffect(() => {
    validateForm.onSetObjectRules(formValidation);
  }, [formData]);

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleUpdateFee = (e) => {
    e.preventDefault();
    const feeList = _.get(formData, 'planning_fee').filter(
      (item) => item.name !== isEditing
    );
    feeList.splice(
      _.get(formData, 'planning_fee').findIndex((i) => i.name === isEditing),
      0,
      { name: _.get(formData, 'name'), amount: _.get(formData, 'amount') || 0 }
    );
    setFormData({
      ...formData,
      planning_fee: feeList,
      amount: '',
      name: '',
    });
    setIsEditing('');
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="full-group-v2">
          <div className="form-row">
            {/* <InputTemplate
              title="Zoning Fee Field"
              htmlFor="amount"
              containerClassName="col-12"
              labelClassName='font-weight-bold'
              formValidatorMsg={validateForm.renderMessage("amount")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="amount"
                  id="amount"
                  placeholder="PHP 0"
                  // className="full-input-v2 text-uppercase my-2"
                  className="full-input-v2"
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData({
                      ...formData,
                      amount: floatValue || ''
                    });
                  }}
                  // disabled={isStatusPaid}
                  isNumericString
                  thousandSeparator
                  // allowLeadingZeros
                  displayType="input"
                  prefix="PHP "
                  value={_.get(formData, "amount") || ''}
                />
              )} 
            /> */}
            <div className="col-12 mt-3">
              <table className="transaction-table table table-striped table-sm">
                <tbody>
                  <tr>
                    <th
                      className="p-2 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                      width="40%"
                    >
                      Fee
                    </th>
                    <th
                      className="p-2 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                      width="40%"
                    >
                      Amount
                    </th>
                    <th
                      className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                      width="20%"
                    />
                  </tr>
                  {!_.isEmpty(_.get(formData, 'planning_fee')) ? (
                    _.get(formData, 'planning_fee')?.map((item) => (
                      <React.Fragment key={item.name}>
                        {_.get(item, 'name') === isEditing ? (
                          <tr style={{ height: '3.5rem' }}>
                            <td>
                              <InputTemplate
                                htmlFor="name"
                                containerClassName="col-12 px-0"
                                labelClassName="font-weight-bold"
                                placeholder="Fee"
                                styles={reactSelectCustomStyleCms()}
                                className="full-input-v2"
                                disabled
                                id="name"
                                name="name"
                                type="input"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    name: e.target.value || '',
                                  })
                                }
                                value={_.get(formData, 'name')}
                                components={{ IndicatorSeparator: () => null }}
                              />
                            </td>
                            <td>
                              <InputTemplate
                                htmlFor="amount"
                                containerClassName="col-12"
                                labelClassName="font-weight-bold"
                                withCustomInputComponent={() => (
                                  <NumberFormat
                                    name="amount"
                                    id="amount"
                                    placeholder="PHP 0"
                                    className="full-input-v2"
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      setFormData({
                                        ...formData,
                                        amount: floatValue || 0,
                                      });
                                    }}
                                    isNumericString
                                    thousandSeparator
                                    displayType="input"
                                    prefix="PHP "
                                    value={_.get(formData, 'amount') || ''}
                                  />
                                )}
                              />
                            </td>
                            <td className="text-center align-middle">
                              <button
                                className="py-1 btn btn-primary cms-bg-color-primary cms-outline-primary"
                                type="button"
                                disabled={
                                  _.isEmpty(_.get(formData, 'name')) ||
                                  _.get(formData, 'amount') < 0 ||
                                  typeof _.get(formData, 'amount') !== 'number'
                                }
                                onClick={handleUpdateFee}
                              >
                                <span className="font-weight-bold">
                                  Save Changes
                                </span>
                              </button>
                            </td>
                          </tr>
                        ) : (
                          <tr style={{ height: '3.5rem' }}>
                            <td className="text-dark align-middle">
                              {_.get(item, 'name') || '-'}
                            </td>
                            <td className="text-dark align-middle">
                              <b>PHP</b> &nbsp;
                              {numberWithCommas(_.get(item, 'amount')) || '-'}
                            </td>
                            <td className="text-center">
                              {isEditing === '' && (
                                <button
                                  type="button"
                                  className="btn btn-blank px-2"
                                  onClick={toggleEdit(item)}
                                >
                                  <i className="far fa-edit icon-edit cms-bg-color-primary" />
                                </button>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr className="text-dark text-center">
                      <td className="text-dark text-center" colSpan="3">
                        No Fees
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <InputTemplate
              // isInputMask
              title="Tracking No."
              htmlFor="tracking_no"
              containerClassName="col-6"
              // formValidatorMsg={validateForm.renderMessage("tracking_no")}
              // Input component props
              placeholder=""
              // className="full-input-v2 text-uppercase"
              labelClassName="font-weight-bold"
              className="full-input-v2"
              id="tracking_no"
              name="tracking_no"
              type="text"
              autoComplete="none"
              onChange={onChange}
              value={_.get(formData, 'tracking_no')?.toUpperCase() || ''}
              disabled
            />
            <InputTemplate
              title="Year"
              htmlFor="year"
              containerClassName="col-6"
              labelClassName="font-weight-bold"
              withCustomInputComponent={() => (
                <DateInputPicker
                  showYearPicker
                  inputClassName="full-input form-input-record-v2"
                  placeholder="YYYY"
                  btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                  onChange={handleOnChangeDate('year')}
                  value={_.get(formData, 'year')?.toString() || ''}
                  disabled
                />
              )}
            />
            <div className="col-12 form-group">
              <label className="form-label-v3 pl-2 pt-2 mb-0">
                Planning Dept. Remarks: {charCount}/255
              </label>
              {createTextArea(
                { key: 'planning_department_remarks' },
                {
                  maxLength: '255',
                  rows: '7',
                  placeholder: 'Enter Remarks...',
                  onKeyUp: handleOnKeyUp,
                }
              )}
            </div>
          </div>

          <div className="mt-2 pt-2 d-flex col-12 cms-text-primary cms-bg-color-primary-light">
            <p>
              Are you sure you want to confirm the approval of this application?
              This will be sent to the Engineering Department Officer to their
              assessment.
            </p>
          </div>
          <div className="d-flex justify-content-end">
            <button
              disabled={approving || !_.isEmpty(isEditing)}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
            >
              <span className="font-weight-bold">
                {approving ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
              </span>
            </button>
            <button
              disabled={approving}
              type="button"
              onClick={closeModal}
              className="mt-3 btn btn-default"
            >
              <span className="font-weight-bold">Cancel</span>
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

ApproveConfirmationModal.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  approvePlanning: PropTypes.instanceOf(Function).isRequired,
  approving: PropTypes.bool.isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  trackingNo: PropTypes.string.isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  getFeesList: PropTypes.instanceOf(Function).isRequired,
  feesList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  approving: api.loading.indexOf(c.APPROVE) > -1,
  feesList: _.get(api, `${c.GET_FEES_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ApproveConfirmationModal);
